// src/Signup.js
import React, { useState } from 'react';
//import { useAuth } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  TextField,
  Button,
  Typography,
  Box,
  Paper,
  Alert
} from '@mui/material';
import './App.css';

export default function Signup() {
  //const emailRef = useRef();
  //const passwordRef = useRef();
  //const { signup } = useAuth();
  const navigate = useNavigate();
  //const [error, setError] = useState('');
  //const [loading, setLoading] = useState(false);

  // Contact form state
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactMessage, setContactMessage] = useState('');
  const [contactSuccess, setContactSuccess] = useState('');

  //const handleSignup = async (e) => {
  //  e.preventDefault();
  //  setError('');
  //  setLoading(true);
//
  //  try {
  //    // TODO: After signup, call setTenantClaim cloud function to bind tenant in Auth custom claims.
  //    await signup(emailRef.current.value, passwordRef.current.value);
  //    navigate('/');
  //  } catch (err) {
  //    setError('Failed to create an account: ' + (err.message || ''));
  //  } finally {
  //    setLoading(false);
  //  }
  //};

  const handleContactSubmit = (e) => {
    e.preventDefault();
    // TODO: send contactName, contactEmail, contactMessage to your support backend
    console.log({ contactName, contactEmail, contactMessage });
    setContactSuccess('Thanks! We’ll be in touch soon.');
    setContactName('');
    setContactEmail('');
    setContactMessage('');
  };

  return (
    <Box
      component="section"
      sx={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/MailExMaxBackground.png)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Container maxWidth="sm" sx={{ py: 8 }}>
        <Paper className="card" elevation={6}>
          <Box p={4}>
            <img
              src="/logo512.png"
              alt="MailExMax Logo"
              className="hero-logo"
            />
            <Typography variant="h4" align="center" gutterBottom>
              Get in touch to get started with MailExMax
            </Typography>

            {contactSuccess && (
              <Alert severity="success" sx={{ mb: 2 }}>
                {contactSuccess}
              </Alert>
            )}

            <Box
              component="form"
              onSubmit={handleContactSubmit}
              sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <TextField
                className="text-field"
                label="Your Name"
                value={contactName}
                onChange={e => setContactName(e.target.value)}
                fullWidth
                required
              />
              <TextField
                className="text-field"
                label="Your Email"
                type="email"
                value={contactEmail}
                onChange={e => setContactEmail(e.target.value)}
                fullWidth
                required
              />
              <TextField
                className="text-field"
                label="Message"
                multiline
                minRows={4}
                value={contactMessage}
                onChange={e => setContactMessage(e.target.value)}
                fullWidth
                required
              />
              <Button
                className="button"
                type="submit"
                variant="contained"
                size="large"
              >
                Send Message
              </Button>
            </Box>

            {/* Back to Home button */}
            <Box mt={4} textAlign="center">
              <Button
                className="button"
                variant="outlined"
                onClick={() => navigate('/')}
              >
                Back to Home
              </Button>
            </Box>

            {/* 
            // Original signup form commented out until tenant claim is implemented
            <Typography variant="h4" align="center" gutterBottom>
              Create Your Account
            </Typography>

            {error && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {error}
              </Alert>
            )}

            <Box
              component="form"
              onSubmit={handleSignup}
              sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
            >
              <TextField
                className="text-field"
                label="Email"
                type="email"
                inputRef={emailRef}
                fullWidth
                required
              />
              <TextField
                className="text-field"
                label="Password"
                type="password"
                inputRef={passwordRef}
                fullWidth
                required
              />
              <Button
                className="button"
                type="submit"
                variant="contained"
                size="large"
                disabled={loading}
              >
                {loading ? 'Signing up…' : 'Sign Up'}
              </Button>
            </Box>
            */}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
